import * as React from "react";
import {FormBodyProps} from "../../../common/props/FormBodyProps";
import SectionView from "../../../layout/section/SectionView";
import WarrantyInfoFrom from "./WarrantyInfoFrom";
import Col from "../../../layout/Col";
import Row from "../../../layout/Row";
import InputFormGroup from "../../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import ContactTitleEditor from "../../../contacts/form/ContactTitleEditor";
import MerchantFormGroup from "../MerchantFormGroup";

type Props = FormBodyProps<WarrantyInfoFrom>;

export default class WarrantyInfoFormBody extends React.PureComponent<Props> {
	render() {
		return (
			<SectionView>
				<div className={"c-asset-form-body"}>
					<Row customClass={"a-mb-20"}>
						<Col lg={6} xl={6}>
							<MerchantFormGroup label="Merchant"
											   placeholder="Please choose"
											   field={this.props.form.merchantId}
											   onChange={this.props.onFieldChange}
							/>
						</Col>
						<Col lg={6} xl={6}>
							<ContactTitleEditor label="Tile"
												placeholder="Please choose"
												field={this.props.form.title}
												focus={this.props.form.hasFocus(this.props.form.title)}
												onChange={this.props.onFieldChange}/>
						</Col>
					</Row>
					<Row>
						<Col lg={6} xl={6}>
							<InputFormGroup label="Boiler serial #"
											field={this.props.form.boiler}
											onChange={this.props.onFieldChange}
											focus={this.props.form.hasFocus(this.props.form.boiler)}/>
						</Col>
						<Col lg={6} xl={6}>
							<InputFormGroup label="Filter serial # (Optional)"
											field={this.props.form.filter}
											onChange={this.props.onFieldChange}
											focus={this.props.form.hasFocus(this.props.form.filter)}/>
						</Col>
					</Row>
					<Row>
						<Col lg={6} xl={6}>
							<InputFormGroup label="Cylinder serial # (Optional)"
											field={this.props.form.cylinder}
											onChange={this.props.onFieldChange}
											focus={this.props.form.hasFocus(this.props.form.cylinder)}/>
						</Col>
						<Col lg={6} xl={6}>
							<InputFormGroup label="Control serial # (Optional)"
											field={this.props.form.control}
											onChange={this.props.onFieldChange}
											focus={this.props.form.hasFocus(this.props.form.control)}/>
						</Col>
					</Row>
				</div>
			</SectionView>
		);
	}
}